/**
 * @file 文档复制按钮，为dom元素添加复制按钮
 * @author wanzhongyun
 */
import {useEffect} from 'react';
import copy from 'copy-text-to-clipboard';

type IGetDomCallback<T extends HTMLElement = HTMLElement, S extends HTMLElement = T> =
    () => [
        T | null | undefined,
        NodeListOf<S> | null | undefined
    ];

const useCopyBtnDom = <T extends HTMLElement = HTMLElement, S extends HTMLElement = T>(
    options: {
        getDom: IGetDomCallback<T, S>,
        onCopy?: (text: string) => void,
    },
    deeps?: ReadonlyArray<any>
) => {
    useEffect(() => {
        const [wrap, itemList] = options.getDom();
        if (wrap && itemList && itemList.length > 0) {
            const copyBtnClick = (event: MouseEvent) => {
                const codeWrap = event.target as HTMLDivElement;
                const codeDom = codeWrap.parentNode?.querySelector('pre');
                const text = codeDom?.innerText || '';
                copy(text);
                options.onCopy?.(text);
            };

            const btnList: HTMLElement[] = [];

            itemList.forEach((codeDiv) => {
                const newBtn = document.createElement('div');
                btnList.push(newBtn);
                newBtn.className = 'code-copy-btn';
                newBtn.title = 'copy to the pasteboard';
                codeDiv.appendChild(newBtn);
                newBtn.addEventListener('click', copyBtnClick);
            });

            return () => {
                btnList.forEach((btnDev) => {
                    btnDev.removeEventListener('click', copyBtnClick);
                    btnDev.parentNode?.removeChild(btnDev);
                });
            };
        }
        // eslint-disable-next-line
    }, deeps);
};

export default useCopyBtnDom;
